import { styles as componentStyles } from './view.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { html, unsafeCSS } from 'lit';

export const customComponentStyle = html`
  <style>
    ${colorHelpersStyles}
  </style>
  <dom-module id="my-list-box-style" theme-for="vaadin-list-box">
    <template>
      <style>
        [part='items'] {
          display: flex;
          flex-direction: column;
        }

        [part='items'] ::slotted(vaadin-item) {
          border-radius: 0;
          padding: 0;
          min-height: calc(4 * var(--spacer));
          line-height: calc(4 * var(--spacer));
          transition: all 0.2s ease-in-out;
          cursor: pointer;
          font-family: var(--font-family-secondary);
          font-size: var(--body-size-large);
          color: var(--main-titles-inputs-600);
        }

        [part='items'] ::slotted(vaadin-item)::before {
          display: none;
        }

        [part='items'] ::slotted(vaadin-item:focus:not([disabled])) {
          border: 1px solid var(--blue-layout-500-focus);
          background-color: transparent;
        }

        [part='items'] ::slotted(vaadin-item:hover:not([disabled])) {
          background-color: var(--chart-051-hover);
        }

        [part='items'] ::slotted(vaadin-item:active:not([disabled])) {
          background-color: var(--chart-100-pressed);
          font-size: var(--body-size-large);
          border: none;
        }

        [part='items'] ::slotted(vaadin-item)::before {
          display: none;
        }

        [part='items'] ::slotted([focus-ring]:not([disabled])) {
          box-shadow: none;
          background-color: var(--grey-layout-chart-100);
        }

        [part='items'] ::slotted(vaadin-item[disabled]) {
          color: var(--grey-layout-200-disabled);
          cursor: default;
          pointer-events: auto;
        }
      </style>
    </template>
  </dom-module>

  <dom-module id="my-item-style" theme-for="vaadin-item">
    <template>
      <style>
        [part='content'] {
          border-radius: 0;
          padding-left: calc(1.5 * var(--spacer));
          padding-right: calc(1.5 * var(--spacer));
          transition: all 0.2s ease-in-out;
          cursor: pointer;
        }

        :host(.success) [part='content'] {
          color: var(--green-layout-100-primary-green);
        }
        :host(.danger) [part='content'] {
          color: var(--red-layout-300-primary);
        }
        :host(.warning) [part='content'] {
          color: var(--orange-layout-050-warning);
        }
        :host(.info) [part='content'] {
          color: var(--blue-layout-400-primary);
        }
        :host(.allowed) [part='content'] {
          background-image: url('app/webcomponents/assets/images/icon-success.svg');
          background-repeat: no-repeat;
          background-position: right 10px center;
          padding-right: 30px;
        }
        :host(.pending) [part='content'] {
          background-image: url('app/webcomponents/assets/images/icon-pending.svg');
          background-repeat: no-repeat;
          background-position: right 10px center;
          padding-right: 30px;
        }
        :host(.not-allowed) [part='content'] {
          background-image: url('app/webcomponents/assets/images/icon-not-allowed.svg');
          background-repeat: no-repeat;
          background-position: right 10px center;
          padding-right: 30px;
        }

        :host([disabled]) [part='content'] {
          cursor: default;
          color: var(--grey-layout-200-disabled);
        }
      </style>
    </template>
  </dom-module>
`;

export const styles = [unsafeCSS(`${commonStyles}`), unsafeCSS(`${componentStyles}`)];
